import { paletteHelper, typographyHelper } from '@property.com.au/ui-kit';
import { format } from 'date-fns/format';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

interface XTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: string;
  };
}

const XTickWrapper = styled.g`
  .xTickText {
    ${typographyHelper('caption')}
    fill: ${paletteHelper('textSecondary')}
  }
`;

const xTickTopMargin = 8;

export const SupplyDemandAndPerformanceGraphXTick: FunctionComponent<XTickProps> = ({
  payload,
  x,
  y,
}) => {
  if (payload && x !== undefined && y !== undefined) {
    const date = new Date(payload.value);
    const formattedMonth = format(date, 'MMM');
    const formattedYear = format(date, 'yyyy');

    return (
      <XTickWrapper transform={`translate(${x},${y + xTickTopMargin})`}>
        <text className="xTickText" textAnchor="middle">
          <tspan x={0}>{formattedMonth}</tspan>
          <tspan x={0} dy="1.2em">
            {formattedYear}
          </tspan>
        </text>
      </XTickWrapper>
    );
  }
  return null;
};
